/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
/**
 * Base class for all the Search services.
 *
 * @private
 * @class Search
 * @module Services
 * @uses Chain
 * @uses ProtocolMixin
 * @uses KeyMixin
 * @uses LimitMixin
 * @uses LanguageMixin
 * @uses UnwrapMixin
 *
 * @constructor
 * @param {Object}   [options] Options to be passed to the search call,
 *     or Array of such options objects to perform batch request.
 * @param {String}   [options.key] An API Key issued from <a href="http://developer.tomtom.com">Developer Portal</a>
 * @param {"http"|"https"} [options.protocol="https"] Protocol's type
 * @param {Boolean}  [options.unwrapBbox=false] Changes the bounding box coordinates allowing longitudes that
 *  exceeds 180 degrees when is necessary. {{#crossLink "Search/unwrapBbox:method"}}More{{/crossLink}}
 * @param {Number}   [options.limit=10] Maximum number of responses that will be returned
 * @param {String}   [options.language=null] Language to use in the response.
 *  The list with all the available codes can be found
 *  <a href="https://developer.tomtom.com/online-search/online-search-documentation/supported-languages">here</a>.
 * @param {Function} [options.callback] Callback function to use in case of success
 * @param {Function} [options.fail=default] Callback function to use in case of failure
 */
/* jshint nomen:false */
define(['rest/search', 'model/search/search', '../chain', '../validators', '../converters', '../worldEdge',
    '../utils', 'model/search/batchSearch', 'common/searchTypes', './searchParameters'],
function(search, model, chain, validators, converters, worldEdge, utils, batchModel, searchTypes, searchParams) {
    'use strict';

    var TYPES = {
            search: searchTypes.search,
            poi: searchTypes.poi,
            category: searchTypes.category,
            geometry: searchTypes.geometry,
            nearby: searchTypes.nearby,
            lowBandwidth: searchTypes.lowBandwidth
        }, fields = searchParams.create();

    function addBoundingBoxParameters(data, boundingBox) {
        data.topLeft = [boundingBox.maxLat, boundingBox.minLon];
        data.btmRight = [boundingBox.minLat, boundingBox.maxLon];
        return data;
    }

    function callbackBestResult(bestResult, callback) {
        return function(response) {
            callback(bestResult ? response[0] : response);
        };
    }

    function Search(options) {
        this.options = options;
        this.defaultFields = utils.clone(fields);
        this.fields = {};
    }

    Search.prototype.TYPE = TYPES;
    Search.prototype.model = model;
    Search.prototype.construct = function() {
        this.fields = utils.addFields.call(this, this.fields);
        // eslint-disable-next-line vars-on-top
        var batchFields = {
            batchItems: {
                validator: validators.arrayOf(this.fields),
                converter: converters.arrayOf(this.fields)
            }
        };
        this.options = this.options || {};
        this.options.__serviceType = 'search';

        if (Array.isArray(this.options)) {
            return chain.call(this, batchFields, this.handleBatchChain, {
                batchItems: this.options
            });
        } else {
            return chain.call(this, this.fields, this.handleChain, this.options);
        }
    };

    Search.prototype.handleBatchChain = function(data, callback) {
        data.batchItems.forEach(searchParams.modifyRequestOptions);
        search.batch(searchParams.modifyFields(this.fields), data, function(results) {
            callback.call(this, batchModel(results));
        });
    };

    function searchQuery(fields) {
        var modifiedFields = searchParams.modifyFields(fields);
        return function(options, callback) {
            return search.search(modifiedFields, options, callback);
        };
    }

    Search.prototype.handleChain = function(data, callback) {
        searchParams.modifyRequestOptions(data);
        worldEdge(searchQuery(this.fields), this.model, data, callbackBestResult(Boolean(data.bestResult), callback),
            addBoundingBoxParameters);
    };
    //TODO We should think how to refactor this, code below does some WEIRD trick.
    //Take a look in fuzzySearch.js how it is called - they call just constructor function
    function searchConstructor(options) {
        return (new Search(options)).construct();
    }

    searchConstructor.prototype.constructor = Search;

    return searchConstructor;
});



// WEBPACK FOOTER //
// ./services/search/search.js